import { createTheme } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';
import { ptBR } from '@material-ui/core/locale';

export default createTheme(
  {
    palette: {
      type: 'light',
      primary: {
        main: '#08312A',
        light: '#13B5E8',
      },
      secondary: {
        main: '#08312A',
        light: '#13B5E8',
      },
      warning: {
        main: amber['400'],
      },
      text: {
        primary: '#556275',
      },
    },
    mixins: {
      toolbar: {
        minHeight: 90,
      },
    },
    shape: {
      borderRadius: 8,
    },
    overrides: {
      MuiAppBar: {
        colorDefault: {
          color: '#556275',
          boxShadow: 'none',
        },
      },
      MuiTab: {
        root: {
          textTransform: 'none',
          fontWeight: 'bold',
        },
      },
      MuiPaper: {
        elevation1: {
          boxShadow: '0px 3px 6px rgba(142, 142, 142, 0.2)',
        },
      },
    },
    props: {
      MuiTabs: {
        indicatorColor: 'primary',
      },
      MuiCheckbox: {
        color: 'primary',
      },
    },
  },
  ptBR,
);
